// extracted by mini-css-extract-plugin
module.exports = {"NiftyTable":"NiftyTable__NiftyTable__aoyN"};